import { useContext } from "react";
import { AppContext } from "../../context/AppContext";
import useHttp from "../../hooks/useHttp";
import { useCallback } from "react";

export const useCallFlow = () => {
  const { fetchData } = useHttp();
  const [appProperties] = useContext(AppContext);

  const getCallFlowList = useCallback((voiceIntegId) => {
    return new Promise((resolve, reject) => {
      if (voiceIntegId) {
        fetchData(`voice/${voiceIntegId}/callFlow`, "GET", null, appProperties).then((response) => {
          if (response) {
            const resData = JSON.parse(response);
            resolve(resData?.data);
          }
        });
      } else {
        reject(new Error("Voice integration ID is required"));
      }
    });
  }, [fetchData, appProperties]);

  return { getCallFlowList };
};
